import { Controller } from "@hotwired/stimulus"

// Saves the whole form as soon as the referee leaves any of its fields — no
// separate "Salvar" button to tap on a phone mid-match. Skips the request
// entirely when nothing changed, so merely tapping in and back out of a
// field doesn't fire a PATCH.
export default class extends Controller {
  static targets = ["field"]

  connect() {
    this.savedValues = this.fieldTargets.map((field) => field.value)
  }

  save() {
    const currentValues = this.fieldTargets.map((field) => field.value)
    if (currentValues.every((value, index) => value === this.savedValues[index])) return

    this.savedValues = currentValues
    this.element.requestSubmit()
  }
}
